<template>
  <div class="account">
    <Alert type="error" class="tip" show-icon>
      <Icon type="md-bulb" slot="icon" />
      <Row slot="desc">
        <Col span="9">分成比例：订单支付金额的<span>30%</span></Col>
        <Col span="9">退费班、报名不过退费等涉及退费的班型，不参与分成；</Col>
        <Col span="9">学习卡或账号余额支付，不参与分成；</Col>
        <Col span="9">单独购买书籍教材、教辅资料，不参与分成；</Col>
      </Row>
    </Alert>
    <Row class="cardList">
      <Col span="8" class="item">
        <Card :bordered="true">
          <p slot="title">每月25日可提现上月结算收益</p>
          <Row class="cardInfo">
            <Col span="12">
              <p>￥{{topInfo.balance}} <span>元</span></p>
              <h6>余额</h6>
            </Col>
            <Col span="12">
              <p>￥{{topInfo.alreadyMoney}} <span>元</span></p>
              <h6>累计提现</h6>
            </Col>
          </Row>
          <h5></h5>
        </Card>
      </Col>
      <Col span="8" class="item">
        <Card :bordered="true">
          <p slot="title">
            <span style="cursor: pointer;" @click="rule=true">
              规则
              <Icon type="ios-hand"/>
            </span>
          </p>
          <Row class="cardInfo">
            <Col span="12">
              <p>￥{{topInfo.anticipatedIncome}} <span>元</span></p>
              <h6>本月预估累计收益</h6>
            </Col>
            <Col span="12">
              <p>￥{{topInfo.yesterdayIncome}} <span>元</span></p>
              <h6>昨日预估收益</h6>
            </Col>
          </Row>
          <h5 style="border-top: 1px solid #E8EAEC;">
            <span class="lf">
              上月收益: {{topInfo.precedingMonthIncom}}
            </span>
            <span class="rt">
              上月退款: {{topInfo.precedingMonthRefoundMoney}}
            </span>
          </h5>
        </Card>
      </Col>
      <Col span="8" class="item">
        <Card :bordered="true">
          <p slot="title">
            交易统计
            <i class="statistics">
              <ButtonGroup size="small" shape="circle">
                <Button :ghost="dateType===2?true:false" @click="changeType(1)" type="primary">本月</Button>
                <Button :ghost="dateType===1?true:false" @click="changeType(2)" type="primary">全部</Button>
              </ButtonGroup>
            </i>
          </p>
          <Row class="cardInfo">
            <Col span="12">
              <p>￥{{orderStatic.orderMoney}} <span>元</span></p>
              <h6>成交订单({{orderStatic.payOrderCount}}个)</h6>
            </Col>
            <Col span="12">
              <p>￥{{orderStatic.refoundMoney}} <span>元</span></p>
              <h6>退款订单({{orderStatic.refoundOrderCount}}个)</h6>
            </Col>
          </Row>
          <h5></h5>
        </Card>
      </Col>
    </Row>
    <div>
      <tabChange/>
    </div>

    <Modal v-model="rule" width="500" title="收益规则">
      <div>
        <h3>关于收益</h3>
        <p>（1）您推荐出去的链接下单付款成功后，您将获得收益；</p>
        <p>（2）每月25日将结算上一个自然月付款成功的订单，结算后的收益自动计入您的余额中，通过绑定银行卡统一发放；</p>
        <p>（3）当出现取消订单、退款等情况时，将相应扣除收益，实际根据系统结算为准；</p>
        <p>（4）学习卡或余额支付，退费班，考试不过退费、报考失败退费服务的课程不参与分成；</p>
        <h3 style="margin-top: 10px;">名词解析</h3>
        <p><b>余额或可提现余额：</b>当前已结算即将发放的收益；</p>
        <p><b>累计收益：</b>累计已结算的收益；</p>
        <p><b>本月预估收益：</b>本月内所成交的订单预估收益-退款金额；</p>
        <p><b>昨日预估收益：</b>昨日内所成交的订单预估收益-退款金额；</p>
        <p><b>上月预估收益：</b>上月内所有订单预估收益 - 上月退款金额；</p>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="rule=false">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import tabChange from "./tabChange";

  export default {
    name: "account",
    components: {
      tabChange
    },
    data() {
      return {
        rule: false,
        topInfo: {},
        orderStatic: {},
        dateType: 1,
      }
    },
    methods: {
      getIncome() {
        this.$store.dispatch('effect/getIncome').then(res => {
          this.topInfo = res;
        })
      },
      getOrderStatic(val) {
        const params = {
          dateType: val
        };
        this.$store.dispatch('effect/getOrderStatic', params).then(res => {
          this.orderStatic = res;
        })
      },
      changeType(val) {
        this.dateType = val;
        this.getOrderStatic(val);
      }
    },
    created() {
      this.getIncome();
      this.getOrderStatic(this.dateType);
    }
  }
</script>
<style scoped lang="scss">
  .account {
    .tip{
      margin-bottom: 20px;
      /deep/ .ivu-col-span-9{
        line-height: 24px;
        height: 24px;
        span{
          color: #e13b29;
          font-size: 16px;
          display: inline-block;
        }
      }
    }
    .cardList {
      margin-left: -10px;
      margin-right: -10px;

      .item {
        padding: 0 10px;

        .title {

        }

        .statistics {
          float: right;
          font-style: normal;

          /deep/ .ivu-tag {
            height: 18px !important;
            line-height: 16px !important;
            margin: 0;
            margin-left: 5px;
            cursor: pointer;
          }

          .ivu-btn {
            height: 18px !important;
            line-height: 16px !important;
            font-size: 12px;
          }

          i {
            font-style: normal;
          }
        }
      }

      .cardInfo {
        p {
          text-align: center;
          font-size: 26px;
          color: #e13b29;

          span {
            font-size: 14px;
            color: #515a6e;
          }
        }

        h6 {
          color: #515a6e;
          margin-top: 8px;
          text-align: center;
          font-size: 14px;
          font-weight: normal;
        }
      }

      h5 {
        height: 35px;
        line-height: 35px;
        font-weight: normal;
        font-size: 14px;
        margin-top: 15px;
        padding: 7px 10px 0 10px;

        .lf {
          float: left;
        }

        .rt {
          float: right;
        }
      }
    }

  }
</style>